import React, { useState, useRef } from "react";
import ContainerCard from "./containerCard";
import { Chevron } from "@speedoc/design-assets/build/icons/index";
import { Remarkable } from "remarkable";
import SectionHeading from "./sectionHeading";
const markdown = new Remarkable();

export default function DropdownCards({ content }) {
  const [open, setOpen] = useState(undefined);
  const component = useRef({});
  const toggleCard = index => setOpen(index === open ? undefined : index);
  const cardHeight = index => component.current.children[index].querySelector(".cardContent .text").offsetHeight;

  return (
    <>
      <SectionHeading title={content.title} subtitle={content.subtitle} className="sectionHeading" />
      <div className="dropdownCards" ref={component}>
        {content?.cards?.map((card, index) => {
          return (
            <div key={index} onClick={() => toggleCard(index)}>
              <ContainerCard key={index}>
                <div className={`cardTitle ${open === index ? "open" : ""}`}>
                  <Chevron />
                  <p className={`title ${open === index ? "open" : ""}`}>{card.title}</p>
                </div>
                <div
                  style={{ height: open !== undefined && open === index ? cardHeight(index) : null }}
                  className={`cardContent ${open === index ? "open" : ""}`}>
                  <p
                    className={`text ${open === index ? "open" : ""}`}
                    dangerouslySetInnerHTML={{ __html: markdown.render(card.content) }}
                  />
                </div>
              </ContainerCard>
            </div>
          );
        })}
      </div>
    </>
  );
}
